import { FC, SVGProps } from "react";

export const PlayIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="8 8 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M15 10l13 10-13 10V14.784" />
    </g>
  </svg>
);
